// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FKwm6DfNqW7lutb6rOhL {
  background-color: var(--white);
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  overflow: hidden;
  grid-column-gap: 3.125rem;
  column-gap: 3.125rem;
  grid-row-gap: 1rem;
  row-gap: 1rem;
  justify-content: space-between;
  min-height: 3.75rem;
}

.lcoRrhxGLnAbCwpsIK9u {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  grid-gap: 1.1rem;
  gap: 1.1rem;
}

.c9p9Uftg4hGEb5a9BK3E {
  max-width: 1.875rem;
  max-height: 1.875rem;
  min-width: 1.875rem;
  width: 100%;
}

.RsTPj2ALGIr1NAmROV8k {
  grid-gap: 0.3125rem;
  gap: 0.3125rem;
}

@media only screen and
  (max-width: 639px) {
  .FKwm6DfNqW7lutb6rOhL {
    grid-column-gap: 0.125rem;
    column-gap: 0.125rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FooterLogos/FooterLogos.module.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,yBAAgB;EAAhB,oBAAgB;EAChB,kBAAa;EAAb,aAAa;EACb,8BAA8B;EAC9B,mBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAW;EAAX,WAAW;AACb;;AAEA;EACE,mBAAe;EACf,oBAAgB;EAChB,mBAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAQ;EAAR,cAAQ;AACV;;AAEA;;EACE;IACE,yBAAe;IAAf,oBAAe;EACjB;AACF","sourcesContent":[".footerLogos {\n  background-color: var(--white);\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  width: 100%;\n  overflow: hidden;\n  column-gap: 50px;\n  row-gap: 16px;\n  justify-content: space-between;\n  min-height: 60px;\n}\n\n.logosBlock {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1.1rem;\n}\n\n.image {\n  max-width: 30px;\n  max-height: 30px;\n  min-width: 30px;\n  width: 100%;\n}\n\n.trustMarks {\n  gap: 5px;\n}\n\n@media (--mobile) {\n  .footerLogos {\n    column-gap: 2px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footerLogos": `FKwm6DfNqW7lutb6rOhL`,
	"logosBlock": `lcoRrhxGLnAbCwpsIK9u`,
	"image": `c9p9Uftg4hGEb5a9BK3E`,
	"trustMarks": `RsTPj2ALGIr1NAmROV8k`
};
export default ___CSS_LOADER_EXPORT___;
